import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PrivaLocalizationModule } from '@priva/localization';

import { ManualFlowFooterComponent } from 'app/features/manual-input-registration/components';
import { finishRowSelection, resetRowSelection } from 'app/state/row-selection/row-selection.actions';
import { getSelectedRows } from 'app/state/row-selection/row-selection.selectors';

import { RowSelectionItem } from '../../models';

@Component({
    selector: 'app-map-row-selector-toolbar',
    templateUrl: './map-row-selector-toolbar.component.html',
    styleUrl: './map-row-selector-toolbar.component.scss',
    imports: [ManualFlowFooterComponent, AsyncPipe, PrivaLocalizationModule],
})
export class MapRowSelectorToolbarComponent {
    private store = inject(Store);

    selectedRows$: Observable<RowSelectionItem[]>;

    constructor() {
        this.selectedRows$ = this.store.select(getSelectedRows);
    }
    onSelectionComplete(): void {
        this.store.dispatch(finishRowSelection());
    }

    cancelSelection() {
        this.store.dispatch(resetRowSelection());
    }
}
